import clsx from 'clsx';
import styles from './maintenance-property.module.scss';

interface MaintenancePropertyProps {
  hasProperty: boolean;
  className?: string;
}

export default function MaintenanceProperty({ hasProperty, className }: MaintenancePropertyProps) {
  return (
    <div className={clsx(className, styles.chipContainer)}>{hasProperty ? 'True' : 'False'}</div>
  );
}
